/* Custom amber range slider driving a Search & Discovery numeric LIST filter.
   Dragging the handles selects a contiguous span of the available values and
   ticks the matching hidden checkboxes, then dispatches `change` so the facet
   form (which auto-submits on change) re-renders the grid. */
(function () {
  class EbFacetRangeList extends HTMLElement {
    connectedCallback() {
      this.min = Number(this.dataset.min || 0);
      this.max = Number(this.dataset.max || 100);

      this.track = this.querySelector('[data-track]');
      this.fill = this.querySelector('[data-fill]');
      this.rMin = this.querySelector('[data-range-min]');
      this.rMax = this.querySelector('[data-range-max]');
      this.nMin = this.querySelector('[data-num-min]');
      this.nMax = this.querySelector('[data-num-max]');
      this.boxes = Array.from(this.querySelectorAll('[data-value-checkbox]'));

      if (!this.rMin || !this.rMax) return;

      this.onInput = this.onInput.bind(this);
      this.commit = this.commit.bind(this);

      [this.rMin, this.rMax].forEach((el) => {
        el.addEventListener('input', this.onInput);
        el.addEventListener('change', this.commit);
      });
      [this.nMin, this.nMax].forEach((el) => {
        el && el.addEventListener('change', () => {
          this.syncFromNumbers();
          this.commit();
        });
      });

      this.paint();
    }

    span() {
      let lo = Number(this.rMin.value);
      let hi = Number(this.rMax.value);
      if (lo > hi) [lo, hi] = [hi, lo];
      return [lo, hi];
    }

    onInput() {
      // prevent handles crossing
      let lo = Number(this.rMin.value);
      let hi = Number(this.rMax.value);
      if (lo > hi) {
        if (document.activeElement === this.rMin) this.rMin.value = hi;
        else this.rMax.value = lo;
      }
      this.paint();
    }

    syncFromNumbers() {
      if (this.nMin) this.rMin.value = this.clamp(Number(this.nMin.value));
      if (this.nMax) this.rMax.value = this.clamp(Number(this.nMax.value));
      this.paint();
    }

    clamp(v) {
      if (isNaN(v)) return this.min;
      return Math.min(this.max, Math.max(this.min, v));
    }

    paint() {
      const [lo, hi] = this.span();
      const range = this.max - this.min || 1;
      const left = ((lo - this.min) / range) * 100;
      const right = ((hi - this.min) / range) * 100;
      if (this.fill) {
        this.fill.style.left = left + '%';
        this.fill.style.right = 100 - right + '%';
      }
      if (this.nMin) this.nMin.value = lo;
      if (this.nMax) this.nMax.value = hi;
    }

    commit() {
      const [lo, hi] = this.span();
      let changed = false;
      this.boxes.forEach((box) => {
        const n = Number(box.dataset.num);
        const inSpan = n >= lo && n <= hi;
        if (box.checked !== inSpan) {
          box.checked = inSpan;
          changed = true;
        }
      });
      // fire one change so the facet form submits once
      if (changed) {
        this.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  if (!customElements.get('eb-facet-range-list')) {
    customElements.define('eb-facet-range-list', EbFacetRangeList);
  }
})();
